import { getDelayAction } from 'automaton/actions/DelayAction'
import { getReelSpinAction } from 'automaton/actions/ReelSpinAction'
import { getRequestSpinAction } from 'automaton/actions/RequestSpinAction'
import { getAutoRespinState } from 'automaton/states/AutoRespinState'
import { getAutoWinState } from 'automaton/states/AutoWinState'
import { getBetState } from 'automaton/states/BetState'
import { AutoSpinManager } from 'managers/AutoSpinManager'
import { signal } from 'services/SignalsService'
import { spinSettings } from 'settings/custom/reels'

import { getCascadeState } from './CascadeState'

export function getAutoState() {
  const winModel = game.models.WinModel.get()
  const spinModel = game.models.SpinModel.get()
  const cascadeModel = game.models.CascadeModel.get()

  if (spinSettings.hasOwnProperty('gamble') && spinSettings.gamble) {
    game.models.GambleModel.setIsGamble(false)
    signal.dispatch('GAMBLE-FEATURE:HIDE-BUTTON')
  }

  const name = 'AUTO'
  const actions = [
    getRequestSpinAction(),
    game.models.GameModel.requestAgainAllowed
      ? getDelayAction(0.1)
      : getReelSpinAction(),
  ]
  const transition = () =>
    game.models.GameModel.requestAgainAllowed
      ? getBetState()
      : cascadeModel.all > -1
        ? getCascadeState()
        : winModel.winLines.length
          ? getAutoWinState()
          : spinModel.respin.length
            ? getAutoRespinState()
            : AutoSpinManager.isAllowed()
              ? getAutoState()
              : getBetState()

  return {
    name,
    actions,
    transition,
  }
}
